<script setup lang="ts">
import type { NavItemProps } from '~/utils/nav'
import { NuxtLink } from '#components'
import { faArrowUpRight } from '@fortawesome/pro-light-svg-icons'
import { twMerge } from 'tailwind-merge'

const props = withDefaults(
  defineProps<NavItemProps>(),
  {
    iconSize: 'sm',
  },
)

const { theme } = useTheme()

const active = useIsActiveRoute(() => props)
</script>

<template>
  <component
    :is="to ? NuxtLink : 'button'"
    :class="twMerge(headerVariants.button({ theme, badge: !!badge, active }), String($attrs.class))"
    :data-dd-privacy="privacy"
    :to="to"
    :external="external"
    :target="external ? '_blank' : undefined"
    :rel="external ? 'noopener noreferrer' : undefined"
    exact-active-class="active"
    :aria-label="srOnly ? label : undefined"
    @click="onClick"
  >
    <IconWithBadge v-if="icon" :icon="icon" :badge="badge" :size="iconSize" />

    <template v-if="!srOnly">
      {{ label }}
    </template>
    <slot />

    <Icon v-if="external && !hideExternalIcon" :icon="faArrowUpRight" size="sm" />
  </component>
</template>
